import { Component } from '@angular/core';
import moment from 'moment';

@Component({
  standalone: false,
  selector: 'app-test-dates',
  templateUrl: './test-dates.component.html',
  styleUrls: ['./test-dates.component.scss']
})
export class TestDatesComponent
{
  public minDOB: Date = moment().subtract('120', 'year').toDate();
  public maxDOB: Date = moment().toDate();
}
